import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import './App.css';

// Lazy load components
const Portfolio = React.lazy(() => import('./components/Portfolio'));
const AllProjectsPage = React.lazy(() => import('./components/AllProjectSection'));

// Loading component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center h-screen">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500">
    </div>
    <p className="ml-3">Loading...</p>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/projects" element={<AllProjectsPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;